import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

const CourseNav = (props) => {
  const { current, currentChild, content, onChange, onChildChange } = props;

  const tabs = content.map(item => {
    if (item.children.length === 0) return null;

    const classes = ['popup-nav__tabs-item'];
    if (current === item.id) classes.push('popup-nav__tabs-item--selected');

    const [isContentShown, setIsContentShown] = useState(current === item.id);
    const [isContentClassShown, setIsContentClassShown] = useState(current === item.id);

    useEffect(() => {
      if (isContentShown) {
        setIsContentClassShown(true);
      } else {
        setIsContentClassShown(false);
      }
    }, [isContentShown]);

    useEffect(() => {
      if (current === item.id && !isContentShown) {
        setIsContentShown(true);
      }
      if (current !== item.id && isContentShown) {
        setIsContentShown(false);
      }
    }, [current]);

    const haveChildrenWithTags = [];
    item.children.forEach(it => {
      if (it.children.length && it.children[0].tag) {
        haveChildrenWithTags.push(it);
      }
    });

    const childrenTabs = haveChildrenWithTags.map(child => {
      const isActive = currentChild === child.id && current === item.id;
      return (
        <button
          key={child.id}
          type="button"
          className={classNames('popup-nav__tabs-child', isActive ? 'popup-nav__tabs-child--selected' : '')}
          onClick={() => onChildChange(child.id)}
        >
          {child.name}
        </button>
      );
    });

    return (
      <>
        <button
          key={`${item.id}-button`}
          type="button"
          className={classes.join(' ')}
          onClick={() => onChange(item.id)}
        >
          {item.name}
        </button>
        {!!haveChildrenWithTags.length &&
        <div
          key={`${item.id}-div`}
          className={classNames(
            'popup-nav__tabs-child-content-wrapper',
            isContentClassShown ? 'parent-active' : ''
          )}
        >
          {isContentShown && !!childrenTabs.length &&
          <div
            className={classNames('popup-nav__tabs-child-content', isContentClassShown ? 'shown' : '')}
          >{childrenTabs}</div>}
        </div>}
      </>
    );
  });

  const classes = ['popup-nav__tabs'];
  if (current) classes.push('popup-nav__tabs--selected');

  return <section className={classes.join(' ')}>{tabs}</section>;
}

export default CourseNav;
